import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import TreatmentBanner from '../sections/TreatmentBanner/TreatmentBanner';
import TreatmentGrid from '../sections/TreatmentGrid/TreatmentGrid';
import Appointment from '../sections/Appointment/Appointment';
import MetaHelmet from '../components/SEO/MetaHelmet';

const Treatments = () => {
    return (
        <>
            <MetaHelmet 
                title="Tedavilerimiz | Mona Klinik"
                description="Mona Klinik'te sunulan tüm diş tedavileri. Pedodonti, protez, implant, ortodonti ve daha fazlası için uzman kadromuzla tanışın."
            />
            <Navbar />
            <TreatmentBanner />
            <TreatmentGrid />
            <Appointment />
            <Footer />
        </>
    );
};

export default Treatments; 